import React, { Fragment, useEffect, useState } from 'react'
import { Avatar } from 'flowbite-react'
import propTypes from "prop-types"
import { Typography } from '..'
import { generateBGColorClassName } from '../../../utils/randomColor';

const SharedPropTypes = {
    imageList: propTypes.array,
    rounded: propTypes.bool,
    stacked: propTypes.bool,
    alt: propTypes.string,
    src: propTypes.any,
    limit: propTypes.number,
    textClassName: propTypes.string,
    size:propTypes.string,
    className : propTypes.string,
};


export const Avatars = (props) => {
    const { type = "svg", } = props
    const TYPES = {
        svg: <SVGAvatar {...props} />,
        img: <ImgAvatar {...props} />,
        text: <ImageWithText {...props} />,
        group: <AvatarGroup {...props} />
    }
    return (
        <div className="flex flex-wrap ">
            {TYPES?.[type] || ""}
        </div>
    )
}

const AvatarGroup = ({ imageList = [], limit = 0 }) => {

    return (<div className="flex flex-wrap gap-2 ">
        {!!imageList?.length && <Avatar.Group>
            {imageList?.map((image, i) =>
                <Fragment key={`${image?.first_name || ''} ${image?.last_name || ''} + ${i}`}>
                    {i < limit &&
                        <ImageWithText type="text" alt={`${image?.first_name || ''} ${image?.last_name || ''}`}
                            textClassName="text-sm "
                            className={`${generateBGColorClassName(i)} !h-10 !w-10 tetx-sm  cursor-pointer`} />
                    }
                </Fragment>
            )}
            {limit < imageList?.length && <Avatar.Counter total={imageList?.length - limit} />}
        </Avatar.Group>}
    </div>)
}

const SVGAvatar = ({ rounded = true, src = "", alt = "Avatar-image", className = "" }) => {
    return (<Avatar alt={alt}
        img={(props) => (
            <div className={`h-[2.7rem] w-[2.7rem] rounded-full m-auto flex items-center justify-center ${className}`}>
                {src}
            </div>
        )} rounded={rounded} />)
}

const ImgAvatar = ({ rounded = true, src = "", alt = "Avatar-image", size = "md" }) => <Avatar src={src} size={size} alt={alt} rounded={rounded} />

const ImageWithText = ({ rounded = true, alt = "Avatar-image", className = "", size = "md", textClassName = '' }) => {

    const [placeHolder, setPlaceHolder] = useState('');

    useEffect(() => {
        const name = alt?.split(' ');
        let string = "";
        name?.length && name?.forEach(element => {
            string += element?.charAt(0)?.toUpperCase()
        });
        setPlaceHolder(string);
        //eslint-disable-next-line
    }, [alt])


    return (<Avatar alt={alt} size={size}
        img={(props) => (
            <div className={`h-[2.7rem] w-[2.7rem] rounded-full m-auto flex items-center justify-center ${className}`}>
                <Typography variant="lg" className={`text-white ${textClassName}`} text={placeHolder} />
            </div>
        )} rounded={rounded} />)
}

AvatarGroup.propTypes = SharedPropTypes;
SVGAvatar.propTypes = SharedPropTypes;
ImgAvatar.propTypes = SharedPropTypes;
ImageWithText.propTypes = SharedPropTypes;
ImageWithText.propTypes = SharedPropTypes;